<template>
  <crud-form
    v-model="payload"
    :page-title="$t('app.modalities.title')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Modalities"
    navigate-page-after-save="ModalitiesConfig"
  >
    <template slot="group-1">
      <form-group
        :title="$t('app.modalities.form.subTitle',
                   { days: payload.numeroDeDiasDePrazoParaProrrogacao})"
        :loading="loading"
      >
        <v-flex
          xs12
          lg7
        >
          <input-money
            id="taxaDeAberturaDoContrato"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.taxaDeAberturaDoContrato"
            maxlength="6"
            separator="."
            :label="$t('app.modalities.form.contractOpeningFee')"
            :loading="loading"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-money
            id="taxaDeBoleto"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.taxaDeBoleto"
            maxlength="6"
            separator="."
            :label="$t('app.modalities.form.billetFee')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-money
            id="garantiaDeVida"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.garantiaDeVida"
            maxlength="6"
            separator="."
            :label="$t('app.modalities.form.lifeWarranty')"
            :loading="loading"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="comissaoGrupoCard"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.comissaoGrupoCard"
            maxlength="7"
            separator="."
            :decimals="4"
            :label="$t('app.modalities.form.commissionGrupoCard')"
            :loading="loading"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="comissaoTecfin"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.comissaoTecfin"
            maxlength="7"
            separator="."
            :decimals="4"
            :label="$t('app.modalities.form.commissionTecfin')"
            :loading="loading"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="iofAoDia"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.iofAoDia"
            maxlength="7"
            :decimals="4"
            separator="."
            :label="$t('app.modalities.form.dailyIof')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="iofTotal"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.iofTotal"
            maxlength="7"
            :decimals="4"
            separator="."
            :label="$t('app.modalities.form.totalIof')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="jurosAplicadosSobreValorDoTitulo"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.jurosAplicadosSobreValorDoTitulo"
            maxlength="7"
            :decimals="4"
            separator="."
            :label="$t('app.modalities.form.taxAppliedOnTitle')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="taxaDeCessaoDoFidcAoDia"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.taxaDeCessaoDoFidcAoDia"
            maxlength="7"
            :decimals="4"
            separator="."
            :label="$t('app.modalities.form.cessionDailyFee')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="taxaDeCessaoDoFidcAoMes"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.taxaDeCessaoDoFidcAoMes"
            maxlength="7"
            :decimals="4"
            separator="."
            :label="$t('app.modalities.form.cessionMonthlyFee')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
        <v-flex
          xs12
          lg7
        >
          <input-percentage
            id="taxaDeCessaoDoFidcParaAModalidade"
            v-model="payload.parametroModalidadeDeProrrogacaoDTO.taxaDeCessaoDoFidcParaAModalidade"
            maxlength="7"
            :decimals="4"
            separator="."
            :label="$t('app.modalities.form.cessionModalitieFee')"
            :loading="loading"
            :thousands="false"
            :rules="[requiredRule]"
          />
        </v-flex>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import InputMoney from 'Support/components/inputs/InputMoney.vue';
import FormGroup from 'Support/layout/FormGroup.vue';
import ModalitiesConfigRequest from 'Domain/modalities/ModalitiesConfigRequest';
import CrudForm from 'Support/components/crud/CrudForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import InputPercentage from 'Support/components/inputs/InputPercentage.vue';

export default {
  name: 'ModalitiesConfigForm',
  components: {
    CrudForm,
    FormGroup,
    InputMoney,
    InputPercentage,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: ModalitiesConfigRequest,
    loading: false,
    payload: {
      id: null,
      numeroDeDiasDePrazoParaProrrogacao: '',
      parametroModalidadeDeProrrogacaoDTO: {
        comissaoGrupoCard: '',
        comissaoTecfin: '',
        garantiaDeVida: '',
        iofAoDia: '',
        iofTotal: '',
        jurosAplicadosSobreValorDoTitulo: '',
        taxaDeAberturaDoContrato: '',
        taxaDeBoleto: '',
        taxaDeCessaoDoFidcAoDia: '',
        taxaDeCessaoDoFidcAoMes: '',
        taxaDeCessaoDoFidcParaAModalidade: '',
      },
    },
  }),
};
</script>
